<template>
  <!-- панель появляется только когда что-то выбрано: пустая полоса с выключенной
       кнопкой занимала верх экрана на каждой группе -->
  <div>
    <div v-if="selectedTeams.length" class="main-actions">
      <h6>
        Выбрано команд: <b>{{ selectedTeams.length }}</b>
      </h6>
      <div class="header-actions">
        <button type="button" class="header-action header-action--ghost"
                @click="selectedTeams = []">
          Снять выбор
        </button>
        <button type="button" class="header-action header-action--primary"
                @click="isShowMoveToNextStageTournamentModal = true">
          Перенести в следующий этап
        </button>
      </div>
    </div>
    <Modals v-model="isShowMoveToNextStageTournamentModal"
            :name="tournament?.game.slug === 'mlbb' ? 'MoveToNextStageMLBBTournament' : 'MoveToNextStageTournament'"
            title="Перенос команд на следующий этап"
            @submit="submitMove"
            :params="{ teams: selectedTeams }" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Modals from "@/components/modals/index.vue";

export default {
  name: "MainActions",
  components: {
    Modals,
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isShowMoveToNextStageTournamentModal: false
    }
  },
  computed: {
    ...mapState('moduleNewTournament', ['tournament']),
    selectedTeams: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue) }
    }
  },
  methods: {
    submitMove() {
      this.selectedTeams = []
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form-tokens";

.main-actions {
  @include tf-tokens-light;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 10px 14px;
  background: var(--tf-bg);
  border: 1px solid var(--tf-primary);
  border-radius: var(--tf-radius);
  box-shadow: var(--tf-shadow-lg);

  position: sticky;
  top: 8px;
  left: 0;
  z-index: 6;

  h6 {
    margin: 0;
    font-size: 13px;
    font-weight: 500;
    color: var(--tf-text);

    b { color: var(--tf-primary); }
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .header-action {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 34px;
    padding: 0 14px;
    border-radius: 10px;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    transition: all .16s ease;

    &--primary {
      border: 0;
      background: var(--tf-primary);
      color: #fff;

      &:hover { filter: brightness(1.07); }
    }

    &--ghost {
      border: 1px solid var(--tf-border);
      background: var(--tf-bg);
      color: var(--tf-muted);
      font-weight: 500;

      &:hover { border-color: var(--tf-primary); color: var(--tf-primary); }
    }
  }
}

body.dark-only .main-actions {
  @include tf-tokens-dark;
}
</style>